import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSessionService } from '../app-session/app-session.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(
    private http: HttpClient,
    private appSession: AppSessionService,
  ) {}

  getApiVersions(): Observable<any> {

    const url = this.appSession.baseUrl + "/api/v1/config/versions";
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    return this.http.get(url, { headers });
  }
}
